import { MenuItemInterface } from '../interfaces/menu-item.interface';
import { APP_ROUTES } from './app-routes.constant';

export const USER_MENU_ITEMS: MenuItemInterface[] = [
  {
    label: 'Histórico de Protocolos',
    url: APP_ROUTES.attendanceHistory.url
  }
];
